import { RootStateOrAny } from 'react-redux';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import { dismissToast, ToastMessage } from '../store/toast/slice';
import React from 'react';
import { useAppSelector, useTypedDispatch } from 'store/hooks';

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant='filled' {...props} />;
});

const Toast = () => {
  const toast: ToastMessage = useAppSelector((state: RootStateOrAny) => state.toast.queue[0]);
  const dispatch = useTypedDispatch();

  const handleClose = () => {
    dispatch(dismissToast());
  };

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      onClose={handleClose}
      open={!!toast}
      autoHideDuration={2000}
    >
      <Alert severity={toast?.type} onClose={handleClose}>
        {toast?.message}
      </Alert>
    </Snackbar>
  );
};

export default Toast;
